module.exports = __webpack_public_path__ + "static/media/Ginesys_SQ_Logo-removebg-preview.4d03c1c4.png";